import type { JobFeedParams } from "./types";

// ============================================
// Value Normalization Mappings
// ============================================

export const COUNTRY_LABELS: Record<string, string> = {
  US: "United States",
  usa: "United States",
  USA: "United States",
  "united states": "United States",
  CA: "Canada",
  canada: "Canada",
  UK: "United Kingdom",
  GB: "United Kingdom",
  "united kingdom": "United Kingdom",
  IN: "India",
  india: "India",
  DE: "Germany",
  germany: "Germany",
  AU: "Australia",
  australia: "Australia",
  FR: "France",
  france: "France",
};

export const COUNTRY_CODES: Record<string, string> = {
  US: "US",
  usa: "US",
  USA: "US",
  "united states": "US",
  CA: "CA",
  canada: "CA",
  UK: "GB",
  GB: "GB",
  "united kingdom": "GB",
  IN: "IN",
  india: "IN",
  DE: "DE",
  germany: "DE",
  AU: "AU",
  australia: "AU",
  FR: "FR",
  france: "FR",
};

export const WORK_MODE_LABELS: Record<string, string> = {
  remote: "Remote",
  Remote: "Remote",
  hybrid: "Hybrid",
  Hybrid: "Hybrid",
  onsite: "On-site",
  "on-site": "On-site",
  "On-site": "On-site",
  Onsite: "On-site",
};

export const WORK_MODE_VALUES: Record<string, string> = {
  remote: "remote",
  Remote: "remote",
  hybrid: "hybrid",
  Hybrid: "hybrid",
  onsite: "onsite",
  "on-site": "onsite",
  "On-site": "onsite",
  Onsite: "onsite",
};

export const JOB_TYPE_LABELS: Record<string, string> = {
  "full-time": "Full Time",
  "Full Time": "Full Time",
  fulltime: "Full Time",
  "part-time": "Part Time",
  "Part Time": "Part Time",
  parttime: "Part Time",
  contract: "Contract",
  Contract: "Contract",
  internship: "Internship",
  Internship: "Internship",
};

export const JOB_TYPE_VALUES: Record<string, string> = {
  "full-time": "full-time",
  "Full Time": "full-time",
  fulltime: "full-time",
  "part-time": "part-time",
  "Part Time": "part-time",
  parttime: "part-time",
  contract: "contract",
  Contract: "contract",
  internship: "internship",
  Internship: "internship",
};

// ============================================
// Default Parameters
// ============================================

/**
 * Default job feed parameters for backward compatibility.
 * Note: Backend now handles defaults, but these are kept for legacy pages.
 */
export const defaultJobFeedParams: JobFeedParams = {
  limit: 10,
  offset: 0,
  location: "US"
};